import { Arrow } from 'icons/Arrow';
import { components, DropdownIndicatorProps } from 'react-select';

const DropdownIndicator = (props: DropdownIndicatorProps) => (
  <components.DropdownIndicator {...props}>
    <Arrow />
  </components.DropdownIndicator>
);

export default DropdownIndicator;
